export type LatLon = {lat: number; lng: number}; // [lat, lon]

export type MapBounds = {
  nw: LatLon;
  se: LatLon;
};

export enum MapOnboardingSteps {
  simpleBoostOnboarding,
  superBoostOnboarding,
}
